import { useAivaActivity } from "@/stores/contexts/AivaActivityContext";

import AIAutomationOverlay from "./AIAutomationOverlay";

/**
 * The one Aiva banner for the whole wizard.
 *
 * Mounted above the step area so it is not part of a step's subtree. Shows only while Aiva is
 * driving or waiting to be acknowledged after a failure; a recording it merely watches shows nothing.
 */
export const AivaBanner = (): JSX.Element | null => {
  const { automation } = useAivaActivity();
  const isRunning = automation.phase !== "idle";

  if (!isRunning) {
    return null;
  }

  return (
    <AIAutomationOverlay
      size="full"
      isFailed={automation.phase === "failed"}
      failureCount={automation.failureCount}
      onStopAutomation={automation.onStop}
      onManualFallback={automation.onManualFallback}
    />
  );
};
